import React, { useEffect } from "react"
//import PropTypes from "prop-types"
import SyncSelect from "react-select"
import AsyncSelect from "react-select/async"
import CreatableSelect from "react-select/creatable"

const colourStyles = {
  control: (styles, state) => ({
    ...styles,
    fontSize: "1rem",
    borderRadius: "0.375rem",
    border: state.isFocused
      ? "1px solid #0B5DE8"
      : "1px solid rgba(209, 213, 219, 1)",
    background: "none",
    // paddingTop: "0.5rem",
    // paddingRight: "0.75rem",
    // paddingBottom: "0.5rem",
    // paddingLeft: "1rem",

    marginTop: "4px",
    paddingTop: "4px",
    paddingRight: "12px",
    paddingBottom: "4px",
    paddingLeft: "10px",
    // lineHeight: "1.5rem",

    // padding-top: 0.5rem;
    // padding-right: 0.75rem;
    // padding-bottom: 0.5rem;
    // padding-left: 0.75rem;
    // font-size: 1rem;
    // line-height: 1.5rem;
  }),

  valueContainer: (styles, state) => ({
    ...styles,
    // fontSize: "1rem",
    // borderRadius: "0.375rem",
    // border: state.isFocused
    //   ? "1px solid #0B5DE8"
    //   : "1px solid rgba(209, 213, 219, 1)",
    // background: "none",
    // paddingTop: "0.5rem",
    // paddingRight: "0.75rem",
    // paddingBottom: "0.5rem",
    // paddingLeft: "1rem",
    // lineHeight: "1.5rem",

    margin: 0,
    padding: 0,

    // padding-top: 0.5rem;
    // padding-right: 0.75rem;
    // padding-bottom: 0.5rem;
    // padding-left: 0.75rem;
    // font-size: 1rem;
    // line-height: 1.5rem;
  }),

  // option: (base, state) => ({
  //   ...base,
  //   fontSize: "1em",
  //   width: "100%",
  //   border: "none",
  //   // padding: "0",
  //   // margin: "0",
  // }),

  // input: (styles, { cx }) => ({
  //   ...styles,
  //   border: "none",
  //   padding: "0",
  // }),
}

const InputSelect = ({
  name,
  error,
  options,
  value,
  variant,
  onChange,
  onSelect,
  async,
  isCreatable,
  // components,
  defaultOptions,
  loadOptions,
  mapping,
  ...rest
}) => {
  const mapValue = (value) => {
    if (!value) return null
    if (value?.label) return

    let _value
    if (Array.isArray(value)) {
      _value = value.map((_) => ({
        label: _[mapping?.label] ? _[mapping?.label] : "",
        value: _,
      }))
    } else {
      _value = {
        label: value[mapping?.label] ? value[mapping?.label] : "",
        value: { ...value },
      }
    }

    // onChange(_value)
  }

  // useEffect(() => {
  //   const hasLabel = Array.isArray(value)
  //     ? value?.some((_) => _?.label)
  //     : value?.label

  //   // if (!hasLabel && mapping?.label && mapping?.label.trim() !== "") {
  //   //   mapValue(value)
  //   // }
  // }, [value])

  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      fontSize: "1rem",
      borderRadius: "0.375rem",
      border: state.isFocused
        ? "1px solid #0B5DE8"
        : "1px solid rgba(209, 213, 219, 1)",
      ...(error ? { border: "1px solid rgba(239, 68, 68, 1)" } : {}),
      background: "none",
      // paddingTop: "0.5rem",
      // paddingRight: "0.75rem",
      // paddingBottom: "0.5rem",
      // paddingLeft: "1rem",

      marginTop: "4px",
      paddingTop: "4px",
      paddingRight: "12px",
      paddingBottom: "4px",
      paddingLeft: "10px",
      // lineHeight: "1.5rem",

      // padding-top: 0.5rem;
      // padding-right: 0.75rem;
      // padding-bottom: 0.5rem;
      // padding-left: 0.75rem;
      // font-size: 1rem;
      // line-height: 1.5rem;
    }),

    valueContainer: (styles, state) => ({
      ...styles,
      // fontSize: "1rem",
      // borderRadius: "0.375rem",
      // border: state.isFocused
      //   ? "1px solid #0B5DE8"
      //   : "1px solid rgba(209, 213, 219, 1)",
      // background: "none",
      // paddingTop: "0.5rem",
      // paddingRight: "0.75rem",
      // paddingBottom: "0.5rem",
      // paddingLeft: "1rem",
      // lineHeight: "1.5rem",

      margin: 0,
      padding: 0,

      // padding-top: 0.5rem;
      // padding-right: 0.75rem;
      // padding-bottom: 0.5rem;
      // padding-left: 0.75rem;
      // font-size: 1rem;
      // line-height: 1.5rem;
    }),

    // option: (base, state) => ({
    //   ...base,
    //   fontSize: "1em",
    //   width: "100%",
    //   border: "none",
    //   // padding: "0",
    //   // margin: "0",
    // }),

    // input: (styles, { cx }) => ({
    //   ...styles,
    //   border: "none",
    //   padding: "0",
    // }),
  }

  if (async)
    return (
      <AsyncSelect
        //components={{ Option }}
        {...rest}
        styles={colourStyles}
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        value={value}
        onChange={(x) => {
          onChange(x)
        }}
        // {...(components ? { components } : {})}
      />
    )

  if (isCreatable) {
    return (
      <CreatableSelect
        {...rest}
        styles={colourStyles}
        error={error}
        variant={variant}
        //placehoder={label}
        //options={country.map(x => ({ value: x.Code, label: x.Name }))}
        options={options}
        // value={mapping ? { label: value[mapping], value } : value}
        // defaultValue={{ label: "test", value }}
        // value={value.label ? value : { label: value[mapping], value }}
        value={value}
        onChange={(x) => {
          onSelect ? onSelect(x) : onChange(x)
          // onSelect(x)
          // onChange(x)
        }}
      />
    )
  }

  return (
    <SyncSelect
      //components={{ Option }}
      {...rest}
      styles={colourStyles}
      error={error}
      variant={variant}
      //placehoder={label}
      //options={country.map(x => ({ value: x.Code, label: x.Name }))}
      options={options}
      // value={mapping ? { label: value[mapping], value } : value}
      defaultValue={{ ...(value ? value : {}) }}
      value={value}
      // value={value.label ? value : { label: value[mapping], value }}
      // value={value}
      onChange={(x) => {
        onSelect ? onSelect(x) : onChange(x)
        // onSelect(x)
        // onChange(x)
      }}
      // {...(components ? { components } : {})}
      //components={{ Option: CustomOption }}
    />
  )
}

InputSelect.defaultProps = {
  variant: "fluid",
}

export default InputSelect
